export default __webpack_public_path__ + "static/media/sofa.2fa70e94.png";